{
  "title": "Raise Dead",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level necromancy",
  "level": 5,
  "castingTime": "1 hour",
  "range": "Touch",
  "components": "V, S, M (a diamond worth at least 500 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You return a dead creature you touch to life, provided that it has been dead no longer than 10 days. If the creature’s soul is both willing and at liberty to rejoin the body, the creature returns to life with 1 hit point.",
    "This spell also neutralizes any poison and cures nonmagical diseases that affected the creature at the time it died. This spell doesn’t, however, remove magical diseases, curses, or similar effects; if these aren’t first removed prior to casting the spell, they take effect when the creature returns to life. The spell can’t return an undead creature to life.",
    "This spell closes all mortal wounds, but it doesn’t restore missing body parts. If the creature is lacking body parts or organs integral for its survival – its head, for instance – the spell automatically fails.",
    "Coming back from the dead is an ordeal. The target takes a -4 penalty to all attack rolls, saving throws, and ability checks. Every time the target finishes a long rest, the penalty is reduced by 1 until it disappears."
  ],
  "spellLists": ["bard", "cleric", "paladin"]
}
